import i18n from '@plugins/i18n';

import { HoldingCollection, Holding } from '@/models';

export class HoldingVctCollection extends HoldingCollection {
    static type = 'HoldingVctCollection';
    static endpoint = Holding.api.byProduct;

    get headers() {
        let headers = [
            // https://growthinvest.atlassian.net/browse/CORE-878
            // this.createHeader('investor_name', i18n.t('investor'), {
            //     path: 'investor.name',
            //     width: '15rem',
            //     minWidth: '15rem'
            // }),
            this.createHeader('name', i18n.t('name'), {
                width: '14rem',
                minWidth: '14rem',
                transform: data => {
                    if (data.item?.multi_investment === true) {
                        return i18n.t('co_invest');
                    }
                    return data.item.name;
                }
            }),
            this.createHeader('pending_allotment', i18n.t('pending_allotment'), {
                filterable: {
                    operators: this.getOperators(['eq'])
                },
                format: 'boolean',
                active: false
            }),
            this.createHeader('gross_investment_amount', i18n.t('gross_investment_value'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '10rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.gross_investment_amount;
                }
            }),
            this.createHeader('invested_amount', i18n.t('invested_amount'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.invested_amount;
                }
            }),
            this.createHeader('tax_relief', i18n.t('tax_relief'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.tax_relief;
                }
            }),
            this.createHeader('share_quantity', i18n.t('share_quantity'), {
                format: 'number',
                width: '8rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.share_quantity;
                }
            }),
            this.createHeader('share_issue_price', i18n.t('share_issue_price'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.share_issue_price;
                }
            }),

            this.createHeader('current_share_price', i18n.t('current_share_price'), {
                column: 'current_share_price',
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                active: !this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.current_share_price;
                }
            }),
            this.createHeader('nav_price', i18n.t('nav_price'), {
                column: 'current_share_price',
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                active: this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.nav_price;
                }
            }),

            this.createHeader('current_value', i18n.t('current_value'), {
                column: 'current_value',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                active: !this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.current_value;
                }
            }),
            this.createHeader('nav', i18n.t('nav_current_value'), {
                column: 'current_value',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                active: this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.nav;
                }
            }),

            this.createHeader('nav_discount', i18n.t('nav_discount'), {
                format: 'percentage',
                formatOptions: super.percentage_format_options,
                width: '9.3rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.nav_discount;
                }
            }),
            this.createHeader('total_dividends', i18n.t('total_dividends'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '10.2rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.total_dividends;
                }
            }),
            this.createHeader('total_exits', i18n.t('total_exits'), {
                format: 'money',
                formatOptions: super.money_format_options,
                width: '8rem',
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.total_exits;
                }
            }),
            // this.createHeader('dri_enrolled', i18n.t('dri_enrolled'), {
            //     format: 'boolean',
            //     width: '8rem',
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.dri_enrolled;
            //     }
            // }),
            // this.createHeader('dri_enrolled_at', i18n.t('dri_enrolled_at'), {
            //     format: 'datetime',
            //     width: '8rem',
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.dri_enrolled_at;
            //     }
            // }),

            this.createHeader('total_return', i18n.t('total_return'), {
                column: 'total_return',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                active: !this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.total_return;
                }
            }),
            this.createHeader('nav_total_return', i18n.t('nav_total_return'), {
                column: 'total_return',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9rem',
                active: this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.nav_total_return;
                }
            }),

            this.createHeader('total_return_moic', i18n.t('total_return_moic'), {
                column: 'total_return_moic',
                format: 'number',
                formatOptions: {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                },
                append: 'X',
                width: '9.2rem',
                active: !this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.total_return_moic;
                }
            }),
            this.createHeader('nav_total_return_moic', i18n.t('nav_total_return_moic'), {
                column: 'total_return_moic',
                format: 'number',
                formatOptions: {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                },
                append: 'X',
                width: '9.2rem',
                active: this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.nav_total_return_moic;
                }
            }),

            // this.createHeader('total_return_irr', i18n.t('total_return_irr'), {
            //     column: 'total_return_irr',
            //     format: 'percentage',
            //     formatOptions: this.percentage_format_options,
            //     width: '8rem',
            //     active: !this.show_nav_totals,
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.total_return_irr;
            //     }
            // }),
            // this.createHeader('nav_total_return_irr', i18n.t('nav_total_return_irr'), {
            //     column: 'total_return_irr',
            //     format: 'percentage',
            //     formatOptions: this.percentage_format_options,
            //     width: '8rem',
            //     active: this.show_nav_totals,
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.nav_total_return_irr;
            //     }
            // }),

            this.createHeader('total_return_percentage', i18n.t('total_return_percentage'), {
                column: 'total_return_percentage',
                format: 'percentage',
                formatOptions: this.percentage_format_options,
                width: '9.2rem',
                active: !this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.total_return_percentage;
                }
            }),
            this.createHeader('nav_total_return_percentage', i18n.t('nav_total_return_percentage'), {
                column: 'total_return_percentage',
                format: 'percentage',
                formatOptions: this.percentage_format_options,
                width: '9.2rem',
                active: this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.nav_total_return_percentage;
                }
            }),

            // this.createHeader('total_return_profit_loss', i18n.t('total_return_profit_loss'), {
            //     column: 'total_return_profit_loss',
            //     format: 'money',
            //     formatOptions: this.money_format_options,
            //     width: '9.2rem',
            //     active: !this.show_nav_totals,
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.total_return_profit_loss;
            //     }
            // }),
            // this.createHeader('nav_total_return_profit_loss', i18n.t('nav_total_return_profit_loss'), {
            //     column: 'total_return_profit_loss',
            //     format: 'money',
            //     formatOptions: this.money_format_options,
            //     width: '9.2rem',
            //     active: this.show_nav_totals,
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.nav_total_return_profit_loss;
            //     }
            // }),

            this.createHeader('total_return_including_tax_relief', i18n.t('total_return_including_tax_relief'), {
                column: 'total_return_including_tax_relief',
                format: 'money',
                formatOptions: this.money_format_options,
                width: '9.2rem',
                active: !this.show_nav_totals,
                transform: data => {
                    if (data.item.merged && data.item.closed) {
                        return null;
                    }
                    return data.item.total_return_including_tax_relief;
                }
            }),
            this.createHeader(
                'nav_total_return_including_tax_relief',
                i18n.t('nav_total_return_including_tax_relief'),
                {
                    column: 'total_return_including_tax_relief',
                    format: 'money',
                    formatOptions: this.money_format_options,
                    width: '9.2rem',
                    active: this.show_nav_totals,
                    transform: data => {
                        if (data.item.merged && data.item.closed) {
                            return null;
                        }
                        return data.item.nav_total_return_including_tax_relief;
                    }
                }
            ),

            this.createHeader(
                'total_return_including_tax_relief_moic',
                i18n.t('total_return_including_tax_relief_moic'),
                {
                    column: 'total_return_including_tax_relief_moic',
                    format: 'number',
                    formatOptions: {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    },
                    append: 'X',
                    width: '11rem',
                    active: !this.show_nav_totals,
                    transform: data => {
                        if (data.item.merged && data.item.closed) {
                            return null;
                        }
                        return data.item.total_return_including_tax_relief_moic;
                    }
                }
            ),
            this.createHeader(
                'nav_total_return_including_tax_relief_moic',
                i18n.t('nav_total_return_including_tax_relief_moic'),
                {
                    column: 'total_return_including_tax_relief_moic',
                    format: 'number',
                    formatOptions: {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                    },
                    append: 'X',
                    width: '11rem',
                    active: this.show_nav_totals,
                    transform: data => {
                        if (data.item.merged && data.item.closed) {
                            return null;
                        }
                        return data.item.nav_total_return_including_tax_relief_moic;
                    }
                }
            ),

            // this.createHeader(
            //     'total_return_including_tax_relief_irr',
            //     i18n.t('total_return_including_tax_relief_irr'),
            //     {
            //         column: 'total_return_including_tax_relief_irr',
            //         format: 'percentage',
            //         formatOptions: this.percentage_format_options,
            //         width: '11rem',
            //         active: !this.show_nav_totals,
            //         transform: data => {
            //             if (data.item.merged && data.item.closed) {
            //                 return null;
            //             }
            //             return data.item.total_return_including_tax_relief_irr;
            //         }
            //     }
            // ),
            // this.createHeader(
            //     'nav_total_return_including_tax_relief_irr',
            //     i18n.t('nav_total_return_including_tax_relief_irr'),
            //     {
            //         column: 'total_return_including_tax_relief_irr',
            //         format: 'percentage',
            //         formatOptions: this.percentage_format_options,
            //         width: '11rem',
            //         active: this.show_nav_totals,
            //         transform: data => {
            //             if (data.item.merged && data.item.closed) {
            //                 return null;
            //             }
            //             return data.item.nav_total_return_including_tax_relief_irr;
            //         }
            //     }
            // ),

            this.createHeader(
                'total_return_including_tax_relief_percentage',
                i18n.t('total_return_including_tax_relief_percentage'),
                {
                    column: 'total_return_including_tax_relief_percentage',
                    format: 'percentage',
                    formatOptions: this.percentage_format_options,
                    width: '10.2rem',
                    active: !this.show_nav_totals,
                    transform: data => {
                        if (data.item.merged && data.item.closed) {
                            return null;
                        }
                        return data.item.total_return_including_tax_relief_percentage;
                    }
                }
            ),
            this.createHeader(
                'nav_total_return_including_tax_relief_percentage',
                i18n.t('nav_total_return_including_tax_relief_percentage'),
                {
                    column: 'total_return_including_tax_relief_percentage',
                    format: 'percentage',
                    formatOptions: this.percentage_format_options,
                    width: '10.2rem',
                    active: this.show_nav_totals,
                    transform: data => {
                        if (data.item.merged && data.item.closed) {
                            return null;
                        }
                        return data.item.nav_total_return_including_tax_relief_percentage;
                    }
                }
            )

            // this.createHeader(
            //     'total_return_profit_loss_including_tax_relief',
            //     i18n.t('total_return_profit_loss_including_tax_relief'),
            //     {
            //         column: 'total_return_profit_loss_including_tax_relief',
            //         format: 'money',
            //         formatOptions: this.money_format_options,
            //         width: '14rem',
            //         active: !this.show_nav_totals,
            //         transform: data => {
            //             if (data.item.merged && data.item.closed) {
            //                 return null;
            //             }
            //             return data.item.total_return_profit_loss_including_tax_relief;
            //         }
            //     }
            // ),
            // this.createHeader(
            //     'nav_total_return_profit_loss_including_tax_relief',
            //     i18n.t('nav_total_return_profit_loss_including_tax_relief'),
            //     {
            //         column: 'total_return_profit_loss_including_tax_relief',
            //         format: 'money',
            //         formatOptions: this.money_format_options,
            //         width: '14rem',
            //         active: this.show_nav_totals,
            //         transform: data => {
            //             if (data.item.merged && data.item.closed) {
            //                 return null;
            //             }
            //             return data.item.nav_total_return_profit_loss_including_tax_relief;
            //         }
            //     }
            // ),

            // this.createHeader('total_return_with_exits', i18n.t('total_return_with_exits'), {
            //     column: 'total_return_with_exits',
            //     format: 'money',
            //     formatOptions: this.money_format_options,
            //     width: '11rem',
            //     active: !this.show_nav_totals,
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.total_return_with_exits;
            //     }
            // }),
            // this.createHeader('nav_total_return_with_exits', i18n.t('nav_total_return_with_exits'), {
            //     column: 'total_return_with_exits',
            //     format: 'money',
            //     formatOptions: this.money_format_options,
            //     width: '11rem',
            //     active: this.show_nav_totals,
            //     transform: data => {
            //         if (data.item.merged && data.item.closed) {
            //             return null;
            //         }
            //         return data.item.nav_total_return_with_exits;
            //     }
            // }),

            // this.createHeader('reconciled', i18n.t('verified'), {
            //     filterable: true,
            //     format: 'boolean',
            //     width: '9rem'
            // })
        ];

        return headers;
    }

    get default_headers() {
        return [
            'name',
            'gross_investment_amount',
            'invested_amount',
            'tax_relief',
            'share_quantity',
            'share_issue_price',
            'nav_discount',
            'total_dividends',
            'total_exits',

            'current_share_price',
            'nav_price',

            'current_value',
            'nav',

            'total_return',
            'nav_total_return',

            'total_return_moic',
            'nav_total_return_moic',

            'total_return_percentage',
            'nav_total_return_percentage',

            'total_return_including_tax_relief',
            'nav_total_return_including_tax_relief',

            'total_return_including_tax_relief_moic',
            'nav_total_return_including_tax_relief_moic',

            'total_return_including_tax_relief_percentage',
            'nav_total_return_including_tax_relief_percentage'
        ];
    }

    get pdf_headers() {
        return [
            'name',
            'gross_investment_amount',
            'invested_amount',
            'tax_relief',
            'share_quantity',
            'share_issue_price',
            'nav_discount',
            'total_dividends',
            'total_exits',

            'current_share_price',
            'nav_price',

            'current_value',
            'nav',

            'total_return',
            'nav_total_return',

            'total_return_percentage',
            'nav_total_return_percentage',

            'total_return_including_tax_relief',
            'nav_total_return_including_tax_relief',

            'total_return_including_tax_relief_percentage',
            'nav_total_return_including_tax_relief_percentage'
        ];
    }

    get xlsx_headers() {
        return [
            'name',
            'gross_investment_amount',
            'invested_amount',
            'tax_relief',
            'share_quantity',
            'share_issue_price',
            'current_share_price',
            'nav_price',
            'current_value',
            'nav',
            'nav_discount',
            'total_dividends',
            'total_exits',
            'total_return',
            'nav_total_return',
            'total_return_moic',
            'nav_total_return_moic',
            'total_return_percentage',
            'nav_total_return_percentage',
            'total_return_including_tax_relief',
            'nav_total_return_including_tax_relief',
            'total_return_including_tax_relief_moic',
            'nav_total_return_including_tax_relief_moic',
            'total_return_including_tax_relief_percentage',
            'nav_total_return_including_tax_relief_percentage'
        ];
    }

    get preset_filters() {
        let filters = {
            ...super.preset_filters,
            tax_status: this.filterOperator('is') + ':VCT'
        };

        if (this.show_closed_positions) {
            filters.show_closed = true;
        }

        return filters;
    }
}

export default HoldingVctCollection;
